// HubSpot fires this on the form container and it bubbles up to the card.
const SUCCESS = 'hs-form-event:on-submission:success';

function showSuccess(card: HTMLElement): void {
	if (card.classList.contains('is-sent')) {
		return;
	}

	const form = card.querySelector<HTMLElement>('.armada-signup__form');
	const success = card.querySelector<HTMLElement>('.armada-signup__success');

	if (!form || !success) {
		return;
	}

	// Keep the card height so the page below does not jump.
	card.style.minHeight = `${card.offsetHeight}px`;
	card.classList.add('is-sent');
	form.hidden = true;
	success.hidden = false;

	if (card.getBoundingClientRect().top < 0) {
		card.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}

	success.querySelector<HTMLElement>('.armada-signup__success-title')?.focus({ preventScroll: true });
}

export default function initSignups(): void {
	document.querySelectorAll<HTMLElement>('[data-armada-signup]').forEach((card) => {
		card.addEventListener(SUCCESS, () => showSuccess(card));
	});
}
